export const WL_RED = "#EF2D3E";
export const WL_BLACK = "#111111";
export const WL_BG_GREY = "#F7F7F7";
export const WL_BG_SOFT = "#F7F7F7";
export const WL_GREEN = "#2ECC71";
export const WL_YELLOW = "#FFC107";
export const WL_RED_DARK = "#d42635";

export const TEXT_PRIMARY = "#111111";
export const TEXT_MUTED = "#6B7280";
export const TEXT_BLACK = "#111111";

export const CARD_BORDER = "#EAEAEA";
export const BORDER = "#EAEAEA";

export const RED = "#EF2D3E";
export const RED_DARK = "#d42635";
export const WHITE_BG = "#FFFFFF";
